<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Sales Reports(Stores)</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item"><a href="/">Reports</a>
                            </li>
                            <li class="breadcrumb-item">Sales Reports
                            </li>
                            <li class="breadcrumb-item active">Stores
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-header">
                    <h4>Reports</h4>
                </div>

                <div class="card-body">
                    <div class="d-flex justify-content-center mt-2 mb-2 row">
                        <div class="col-md-6 col-xl-6 col-sm-12 col-xs-12">
                            <div class="col-md-12">
                                <div class="form-group"><label>Choose State</label><br>
                                    <select class="form-control" v-model="state">
                                        <option value="">All states</option>
                                        <option v-for="state in states" :value="state.id" :key="state.id">
                                            {{ state.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-xl-12 col-md-12"><label>Status</label><br>
                                <select class="form-control" v-model="status">
                                    <option value="">Select Status</option>
                                    <option v-for="status in statuses" :key="status"
                                            :value="status">
                                        {{ status }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-xl-12 col-md-12 col-xs-12"><label>&nbsp;</label><br>
                                <button type="submit" class="btn btn-primary" @click="getReport">Filter</button>
                                <button type="button" class="btn btn-default" @click="resetFilter">Reset</button>
                            </div>
                        </div>

                        <div class="col-md-6 col-xl-6 col-sm-12 col-xs-12">
                            <div class="col-xl-12 col-md-12 col-xs-12"><label>Start date</label><br>
                                <date-time-field required="required" class="form-control" v-model="from" bound="start"></date-time-field>
                            </div>

                            <div class="col-xl-12 col-md-12 col-xs-12 mt-1"><label>End date</label><br>
                                <date-time-field required="required" class="form-control" v-model="to" bound="end"></date-time-field>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-4 col-sm-6 d-flex">
                        <download-excel ref="exporter-csv" v-show="false" type="csv" :data="exportRows" :name="generateReportName('Sales_Report(Stores)', '.csv')" sheet-name="Report" />
                        <download-excel ref="exporter-xls" v-show="false" :data="exportRows" :name="generateReportName('Sales_Report(Stores)', '.xls')" />
                        <a href="#" @click.prevent="exportReportData('admin.reports.sales.stores', {}, { from, to, status, state }, 'csv')" class="export-link">
                            <i class="fas fa-file-csv"></i> Export to CSV</a> | &nbsp;
                        <a href="#" @click.prevent="exportReportData('admin.reports.sales.stores', {}, { from, to, status, state }, 'xls')" class="export-link text-warning">
                            <i class="fa fa-file-excel-o"></i> Export to Excel</a>
                    </div>
                    <BarChart :chart-data="reportData" :chart-options='{responsive: true}'/>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import {Link} from '@inertiajs/vue2';
import BarChart from "../../../Shared/BarChart";
import TableExportMixin from "../../../Shared/Mixins/TableExportMixin";

export default {
    metaInfo: {title: 'Platform Reports'},
    props: [
        'salesPerStore',
        'states',
        'statuses',
        'totalSalesPerStore'
    ],
    layout: Layout,
    name: 'StoreReport',
    components: {
        BarChart,
        Link,
    },
    mixins: [TableExportMixin],
    data: () => ({
        from: null,
        to: null,
        status: '',
        state: '',
        reportData: null,
        excelData: {},
        exportRows: [],
    }),
    mounted() {
        this.excelData = this.salesPerStore;
        this.reportData = this.generateReportDataset(this.salesPerStore,
            `Sales Reports (${this.totalSalesPerStore})`);
    },

    methods: {

        generateReportDataset(report, label) {
            let reportData = {
                labels: [],
                datasets: [
                ],
            }

            let data = []

            for (const key in report) {
                reportData.labels.push(key);
                data.push(report[key]);
            }
            reportData.datasets.push({
                label: label ?? 'Sales Reports',
                backgroundColor: '#00B5B8',
                data
            })
            return reportData;
        },
        generateReportName(name, fileType) {
            let now = new Date();
            let formatted = now.getFullYear() + '-' +
                String(now.getMonth() + 1).padStart(2, '0') + '-' +
                String(now.getDate()).padStart(2, '0') + '_' +
                String(now.getHours()).padStart(2, '0') + '-' +
                String(now.getMinutes()).padStart(2, '0') + '-' +
                String(now.getSeconds()).padStart(2, '0');

            return `${name}_${formatted}${fileType}`;
        },

        async getReport() {
            try {
                let routeName = 'admin.reports.sales.stores';

                let response = await axios.get(route(routeName), {
                    params: {
                        from: this.from,
                        to: this.to,
                        status: this.status,
                        state: this.state,
                        api: true,
                    },
                    headers: {
                        "X-Requested-With": "XMLHttpRequest",
                    },
                });

                this.excelData = response.data.salesPerStore;
                this.reportData = this.generateReportDataset(response.data.salesPerStore, `Sales Reports (${response.data.totalSalesPerStore})`);

            } catch (e) {
                console.log(e);
            }
        },

        async resetFilter(){
            this.from = null;
            this.to = null;
            this.status = '';
            this.state = '';
            await this.getReport();
        }
    },
}
</script>
